import OpsPage from './OpsPage'

export default function Ops() {
  return <OpsPage />
}
